<template>
  <BaseList listSubtitulo="Lista de serviços" :data="dados.results" :columns="columns" :globalFilterFields="columns"
            :totalRecords="dados.count" @update:pagination="loadDataLazy">
    >
    <template v-slot:incluirCadastro>
      <button v-if="isStaff" id="id_incluir" class="btn btn-primary btn-sm font-bold modalIncluir"
              @click="abrirModal('cadastro')"
              title="Incluir novo registro.">
        <i class="fa fa-plus"></i> INCLUIR
      </button>
    </template>

    <template #actions="{ data }">
      <div class="dropdown text-center">
        <button
            class="btn btn-info btn-sm dropdown-toggle font-bold"
            type="button"
            data-toggle="dropdown" data-boundary="window"
            aria-haspopup="true"
            aria-expanded="false"
        >
          OPÇÕES
        </button>
        <ul class="dropdown-menu p-2 border-0 shadow-sm rounded-3">
          <li>
            <button class="btn btn-outline-primary font-bold mb-1 w-100 rounded"
                    @click="abrirModal('tabs', 'info', data.id, data.key)">
              <i class="fa fa-eye"></i> Visualizar
            </button>
          </li>
          <li>
            <button class="btn btn-outline-custom-orange font-bold mb-1 w-100 rounded"
                    @click="abrirModal('tabs', 'edit', data.id, data.key)">
              <i class="fa fa-edit"></i> Atualizar
            </button>
          </li>
          <li>
            <button class="btn btn-outline-danger font-bold mb-1 w-100 rounded"
                    @click="deletarItem(data.key, data.id, data.descricao, data.profissional)">
              <i class="fa fa-trash"></i> Excluir
            </button>
          </li>
        </ul>
      </div>
    </template>
  </BaseList>
  <CadastrarServicos
      v-if="modalAtivo === 'cadastro'"
      :idModal="'cadastarServico'"
      @fechar="fecharModal"
      @atualizarLista="atualizarListaDados"
  />
  <TabsModalServico
      v-if="modalAtivo === 'tabs'"
      :idModal="'TabsModal'"
      :itemKey="itemKeySelect"
      :tabSelect="tabSelect"
      @fechar="fecharModal"
      @atualizarDados="atualizaDados"
  />
</template>

<script>
import BaseList from "@/components/base/BaseList.vue";
import CadastrarServicos from "@/views/servicos/CadastrarServicos.vue";
import TabsModalServico from "@/views/servicos/TabsModalServico.vue";
import {apiRequest, alertDelete} from "../../../public/js/utils/funcoes";
import {apiUrl} from "@/router/apiBackRoutes";


export default {
  name: "ListaEtapas",
  components: {
    BaseList,
    CadastrarServicos,
    TabsModalServico,
  },
  data() {
    return {
      dados: {
        results: [],
        count: 0,
      },
      pagination: {
        page: 1,
        page_size: 10,
      },
      erro: null,
      modalAtivo: null,
      tabSelect: 'info',
      itemSelect: null,
      itemKeySelect: null,
      isStaff: localStorage.getItem('admin_isStaff'),
      columns: [
        {field: 'id', header: 'ID', align: 'text-right',},
        {field: 'descricao', header: 'DESCRIÇÃO'},
        {field: 'profissional', header: 'PROFISSIONAL'},
        {field: 'construcao_exibicao', header: 'CONSTRUÇÃO'},
        {field: 'unidade_medida', header: 'UNIDADE MEDIDA'},
        {field: 'quantidade', header: 'QUANTIDADE', align: 'text-right'},
        {field: 'valor_total', header: 'VALOR TOTAL', align: 'text-right'},
        {
          field: 'status_financeiro',
          header: 'STATUS FINANCEIRO',
          body: row => row.status_financeiro || '',
          align: 'text-center',
        },
        {
          field: 'status_execucao',
          header: 'STATUS EXECUÇÃO',
          body: row => row.status_execucao || '',
          align: 'text-center',
        },
      ],
    };
  },
  methods: {
    atualizarListaDados(novoDado) {
      this.loadDataLazy({page: 1, page_size: this.pagination.page_size});
    },
    atualizaDados(dadoAtualizado) {
      const index = this.dados.results.findIndex(dado => dado.id === dadoAtualizado.id);
      if (index !== -1) {
        this.dados.results[index] = dadoAtualizado;
      }
    },
    abrirModal(tipo, modal = null, id = null, key = null) {
      this.modalAtivo = tipo;
      this.tabSelect = modal
      if (key) {
        this.itemKeySelect = key;
      }
      if (id) {
        this.itemSelect = id;
      }
    },
    fecharModal() {
      this.modalAtivo = null;
    },
    deletarItem(itemKey, itemId, itemDescricao, itemNome) {
      let url = apiUrl.servicos.retrieveUpdateDestroy(itemKey);
      alertDelete(itemKey, url, 'Você deseja deletar o registro?', `ID: ${itemId} | ${itemDescricao} - ${itemNome}`, () => {
        this.loadDataLazy(this.pagination);
      });
    },
    async loadDataLazy(paginationParams = this.pagination) {
      this.pagination = {
        page: paginationParams.page,
        page_size: paginationParams.page_size,
      };

      const params = {
        page: this.pagination.page,
        page_size: this.pagination.page_size,
      };

      if (paginationParams.search) {
        params.search = paginationParams.search;
      }

      const resultado = await apiRequest("GET", apiUrl.servicos.createList, params);

      if (resultado.success) {
        this.dados.results = resultado.data.results || [];
        this.dados.count = resultado.data.count || 0;
      } else {
        this.$toastMessage("warn", "Atenção", "Erro ao carregar registro!");
        console.error("Erro ao carregar:", resultado.error);
      }
    },
    async getDados() {
      await this.loadDataLazy();
    },
  },
  mounted() {
    this.getDados();
  },
};
</script>
